var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaisingPricesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 30L24 48 7.5 30h6V12h21v18h6z",
    fill: "#597EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h3v12h-3V0z",
    fill: "#ADC6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12h3v3h-3v-3z",
    fill: "#1D39C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3h3v6h-3V3zM28.5 3h3v6h-3V3zM24 27a1.501 1.501 0 010-3c.828 0 1.5.672 1.5 1.5h3c0-1.956-1.256-3.605-3-4.225V18h-3v3.275c-1.744.62-3 2.269-3 4.225A4.5 4.5 0 0024 30a1.501 1.501 0 010 3c-.828 0-1.5-.672-1.5-1.5h-3c0 1.957 1.256 3.605 3 4.225V39h3v-3.275c1.744-.62 3-2.269 3-4.225A4.5 4.5 0 0024 27z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/raising-prices-icon.46d1bf7b4981c74caad504cb6c44cc4e.svg";
export { SvgRaisingPricesIcon as ReactComponent };